import React, { useState, useEffect, useRef } from "react";
import { Text } from "@mantine/core";
import dayjs from "dayjs";

export interface TimeComponentProps {
  /** Dayjs-compatible format string (e.g., "h:mm A", "MMMM D, YYYY", "HH:mm") */
  format: string;

  /** Additional CSS class name for styling */
  className?: string;

  /** Inline styles */
  style?: React.CSSProperties;
}

export const TimeComponent: React.FC<TimeComponentProps> = ({
  format,
  className,
  style,
}) => {
  const [currentTime, setCurrentTime] = useState(() => dayjs());
  const timeIntervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    // Update time every minute
    timeIntervalRef.current = setInterval(() => {
      setCurrentTime(dayjs());
    }, 60000);

    return () => {
      if (timeIntervalRef.current) {
        clearInterval(timeIntervalRef.current);
      }
    };
  }, []);

  const formattedTime = currentTime.format(format);

  return (
    <Text
      className={className}
      style={{
        color: "inherit",
        fontSize: "inherit",
        fontWeight: "inherit",
        fontFamily: "inherit",
        lineHeight: "inherit",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {formattedTime}
    </Text>
  );
};
